import Component from "../../../../lib/component";
import {CollapserConfig} from "../index";

export const CollapserBodyConfig = {
    baseHtmlClass: 'collapser__body',
    selector: '.collapser__body',
};

export class CollapserBody extends Component {

    constructor(id_or_element, collapser) {
        super({
            element: id_or_element,
            config: CollapserBodyConfig
        });

        this.collapser = collapser;

        this.render()
    }

    isOpen() {
        return !!this.collapser?.isOpen();
    }

    isCollapsable() {
        return !!this.collapser?.isCollapsable();
    }

    render() {
        this.swapHtmlClassStates(this.isCollapsable(), CollapserConfig.collapsableClassModifier, CollapserConfig.uncollapsableClassModifier)
        this.swapHtmlClassStates(this.isOpen(), CollapserConfig.openClassModifier, CollapserConfig.closedClassModifier);
    }


}
